import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { sendDwh } from 'reactApp/utils/ga';

// определяет тип фримиума для аналитики
const getFreemiumTypeForAnalytics = (): 'soft' | 'hard' | 'trial' => {
    const freemiumTypeParam = getFeature('freemium-type') as 'soft' | 'hard' | undefined;
    if (freemiumTypeParam === 'soft') {
        return 'soft';
    }
    if (freemiumTypeParam === 'hard') {
        return 'hard';
    }
    return 'trial';
};

// получает суффикс для имени аналитики в зависимости от типа фримиума
const getAnalyticsNameSuffix = (): string => {
    const type = getFreemiumTypeForAnalytics();
    if (type === 'soft') {
        return 'soft_freemium';
    }
    if (type === 'hard') {
        return 'hard_freemium';
    }
    return 'trial';
};

// отправляет аналитику для модалки про фичи фримиума
export const sendFreemiumAboutModalAnalytics = (action: 'show' | 'click' | 'close', clickType?: 'how_work' | 'add_member'): void => {
    const suffix = getAnalyticsNameSuffix();
    const name = `family_${suffix}_subscription_information${clickType ? `_${clickType}` : ''}`;

    sendDwh({
        eventCategory: 'modal',
        action,
        dwh_enabled: true,
        dwhData: {
            name,
        },
    });
};
